import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

// The seven locales the marketplace ships (config.languages). They are imported
// statically on purpose: together they are <9 KB, and it keeps
// `applyDateLocale` synchronous so nothing can format a date before the locale
// is in place. moment's locale, by contrast, has to load lazily — see
// util/dateLocale.js.
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/nn';
import 'dayjs/locale/sv';

/**
 * The single configured dayjs instance for the eager (main-bundle) code path.
 *
 * moment is ~176 KB before locales and used to sit in the main bundle only
 * because a handful of always-loaded modules formatted dates. dayjs core + the
 * two plugins + the seven locales come to ~18 KB raw, so the eager path uses
 * this module and moment now survives only inside code-split chunks
 * (ManageAvailabilityCalendar, PassCard, Storyblok, MUI's
 * AdapterMoment).
 *
 * Plugins are extended exactly once, here. Do not call `dayjs.extend()`
 * anywhere else, and import this module rather than 'dayjs' directly so the
 * plugins are guaranteed to be registered.
 *
 * - `utc` provides `dayjs.utc()` / `.utc()`.
 * - `customParseFormat` provides format-driven parsing, e.g. the 'DD.MM.YYYY'
 *   policy dates coming from Storyblok (ducks/startUp.duck.js).
 */
dayjs.extend(utc);
dayjs.extend(customParseFormat);

export default dayjs;
